import BackButton from 'components/BackButton';
import InvoiceCard from 'components/InvoiceCard';
import { InvoiceStatus } from 'constants/invoice';
import {
  useInvoiceConditionallyWithOrientation,
  useInvoiceNext
} from 'data/useInvoice';
import { useInvoice } from 'hooks/invoice';
import React, { useCallback, useEffect, useState } from 'react';

import InvoicePosting from '@components/InvoicePosting';

import InvoiceDetailButtonsComponent from './InvoiceDetailButtonsComponent';
import InvoiceDetailComponent from './InvoiceDetailComponent';
import { CustomPageContainer, Content, BackButtonContainer } from './styles';

const InvoiceDetail: React.FC = () => {
  const [scrollViewOrientation, setScrollViewOrientation] = useState<
    'RIGHT' | 'LEFT' | null
  >(null);

  const { setInvoiceData } = useInvoice();
  const { invoice } = useInvoiceConditionallyWithOrientation(
    scrollViewOrientation
  );
  const { invoice: invoiceNext } = useInvoiceNext();

  useEffect(() => {
    setInvoiceData(invoice);
  }, [invoice]);

  const invoiceDetailButtonsCallback = useCallback(index => {
    setScrollViewOrientation(index === 0 ? 'LEFT' : 'RIGHT');
  }, []);

  return (
    <CustomPageContainer>
      <BackButtonContainer>
        <BackButton />
      </BackButtonContainer>
      <Content testID="invoice-content">
        {invoiceNext && (
          <InvoiceDetailButtonsComponent
            callback={invoiceDetailButtonsCallback}
          />
        )}
        <InvoiceCard
          orientation={scrollViewOrientation}
          testID="currentInvoiceCard"
          horizontalButton
          showButton={invoice?.status === InvoiceStatus.ATUAL}
        />
        <InvoiceDetailComponent invoice={invoice} />
        <InvoicePosting
          data={invoice?.topPurchases}
          title="Lançamentos da fatura"
          showAllButton
        />
      </Content>
    </CustomPageContainer>
  );
};

export default InvoiceDetail;
